import { render, staticRenderFns } from "./UserApp.vue?vue&type=template&id=4ddc3494&scoped=true"
import script from "./UserApp.vue?vue&type=script&lang=js"
export * from "./UserApp.vue?vue&type=script&lang=js"
import style0 from "./UserApp.vue?vue&type=style&index=0&id=4ddc3494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc3494",
  null
  
)

export default component.exports